import './App.css';
import { LoaderProvider } from './context/LoaderContext';
import { SnackbarProvider } from './context/SnackbarContext';
import RegistroAsistencia from './RegistroAsistencia';
import { Container } from '@mui/material';

function App() {
  return(   
    <SnackbarProvider>
      <LoaderProvider>
        <Container maxWidth="sm" sx={{mt:2, px:2}}>
          <RegistroAsistencia/>
          {/*<AlertDialog/>*/}
        </Container>
      </LoaderProvider>
    </SnackbarProvider>
  )
}

export default App;